import { Component, EventEmitter, Input, Output } from '@angular/core'

import { Department } from '@app/features/scoping/models/department.model'
import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { UpdateRolePayload, ScopeElementsConfig } from '../models'
import { trackById } from '@app/shared/utils/utils'

@Component({ selector: 'scope-roles', templateUrl: './roles.component.html', styleUrls: ['./roles.component.scss'] })
export class RolesComponent {
  @Input() config: ScopeElementsConfig
  @Input() level: number
  @Input() department: Department
  @Input() component: ScopeComponent

  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  protected readonly trackById = trackById
}
